import React, {useMemo, useEffect, useRef} from "react";
import SkSubmitButtonProps from "./SkSubmitButtonProps";
import {Button, Spinner} from "react-bootstrap";
import {SkFormStoreChecker} from "./SkFormContexts";
/* eslint-disable react-hooks/rules-of-hooks */
/**
 * Эта кнопка, в отличии от SkSubmitButton, дизейблится, когда нечего сабмитить
 * НЕ УМЕЕТ accepts и требует находиться внутри SkFormStoreContext
 * @param props
 * @constructor
 */
const SkFormBlockSubmitButton:React.FC<SkSubmitButtonProps> = (props) => {
  const disabled = useMemo(() => props.disabled || props.formikProps.isSubmitting || !props.formikProps.isValid, [props.disabled, props.formikProps.isSubmitting, props.formikProps.isValid]);
  const isInvalid = !props.formikProps.isValid;
  const lastLoggedErrors = useRef<string>("");

  // Debug logging for form validation - only log when errors change
  useEffect(() => {
    if (isInvalid) {
      const currentErrorsString = JSON.stringify(props.formikProps.errors);
      
      // Only log if errors have changed to avoid console spam
      if (lastLoggedErrors.current !== currentErrorsString) {
        lastLoggedErrors.current = currentErrorsString;
        
        console.group("🚫 SkFormBlockSubmitButton: Form validation failed");
        console.log("Form validation summary:");
        console.log("  - isValid:", props.formikProps.isValid);
        console.log("  - isSubmitting:", props.formikProps.isSubmitting);
        console.log("  - disabled:", disabled);
        
        console.log("\n📋 All Formik errors:", props.formikProps.errors);
        console.log("👆 All touched fields:", props.formikProps.touched);
        console.log("💾 All form values:", props.formikProps.values);
        
        // Log specific invalid fields with details
        const invalidFields = Object.keys(props.formikProps.errors);
        if (invalidFields.length > 0) {
          console.log(`\n❌ ${invalidFields.length} invalid field(s):`, invalidFields);
          invalidFields.forEach(fieldName => {
            console.group(`Field: "${fieldName}"`);
            console.log("❌ Error:", props.formikProps.errors[fieldName]);
            console.log("💾 Current value:", props.formikProps.values[fieldName]);
            console.log("👆 Touched:", props.formikProps.touched[fieldName]);
            console.log("🔍 Value type:", typeof props.formikProps.values[fieldName]);
            console.log("📏 Value length:", props.formikProps.values[fieldName]?.length || 'N/A');
            console.groupEnd();
          });
        } else {
          console.log("🤔 No field errors found, but form is still invalid");
        }
        
        console.groupEnd();
      }
    } else {
      // Reset when form becomes valid
      lastLoggedErrors.current = "";
    }
  }, [isInvalid, props.formikProps.errors, props.formikProps.touched, props.formikProps.values, disabled]);
  return <SkFormStoreChecker name={"SkFormBlockSubmitButton"}>
    {(formStore) => {
      const hasChanges = useMemo(() => formStore.questionsChanged !== 0, [formStore.questionsChanged]);
      return <>
        <Button className={"flex-grow-1"} variant="primary" type="submit" disabled={disabled || !hasChanges} block size="lg">
          {props.formikProps.isSubmitting
            ? <><Spinner
              as="span"
              animation="border"
              role="status"
              aria-hidden="true"
            /></>
            : props.caption
          }
        </Button>
      </>;
    }}
  </SkFormStoreChecker>;
};
export default SkFormBlockSubmitButton;